import { GraphQLClient } from "graphql-request";

import { getSdk } from "@/graphql/generated";

const client = new GraphQLClient(
  `https://${process.env.NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN}/api/${process.env.NEXT_PUBLIC_SHOPIFY_API_VERSION}/graphql.json`,
  {
    headers: {
      "X-Shopify-Storefront-Access-Token":
        process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN || "",
    },
  }
);

const GRAPHQL_CLIENT = getSdk(client);

export default GRAPHQL_CLIENT;

